<script setup>
import { ref } from 'vue';
import Icon from '../Common/Icon.vue';
import Image from '../Common/Image.vue';
import { useLocalizationStore } from '../../stores/localizationStore';

const props = defineProps({
    tab: Object,
});

const { $localize } = useLocalizationStore();

const openTooltip = ref(null);

function toggleTooltip(i){
    openTooltip.value = (openTooltip.value === i) ? null : i;
}

function isTooltipActive(i){
    return i === openTooltip.value;
}

</script>

<template>
    <div>
        <Image
            v-if="tab.image?.src"
            :light-box="true"
            :image="tab.image"
            class="h-72 4k:h-96"
        />
        <div class="pt-4 divide-y divide-white pr-5">
            <div
                v-for="(row, i) in $localize(tab.table)"
                :key="i"
                class="flex r-text-22 gap-x-5 py-4"
            >
                <h2 v-text="row.headline"></h2>
                <p class="ml-auto" v-text="row.content"></p>

                <button
                    v-if="row.tooltip"
                    type="button"
                    class="size-8 text-left relative rounded-full border border-white grid place-items-center"
                    @click="toggleTooltip(i)"
                    :class="isTooltipActive(i) ? 'bg-white text-secondary' : 'hover:bg-white hover:text-secondary transition-colors'"
                >
                    <div
                        class="tooltip absolute -right-5 bottom-14 bg-white text-gray-900 r-text-22 font-regular p-5 pb-4 whitespace-pre shadow-lg z-50 rounded-md"
                        v-text="row.tooltip"
                        v-show="isTooltipActive(i)"
                    ></div>
                    <Icon name="info-i" class="size-4" />
                </button>
            </div>
        </div>
    </div>
</template>
